import BaseEllipsisMenu from 'components/BaseEllipsisMenu/BaseEllipsisMenu';
import { usePerms } from 'contexts/PermsContext';
import { Button } from 'react-bootstrap';
import { hasDevicePermissionFromDevice } from '../../utils/devicePermissions.utils';

const ActionMenu = ({
  entityType,
  entity,
  menuKey,
  openMenus,
  setOpenMenus,
  onEdit,
  onRemove,
  className,
}) => {
  const perms = usePerms();
  const canEdit =
    entityType === 'system'
      ? perms.testPermission([8, 9, 10, 11, 12, 13], ['Create-EditIntegrations'])
      : hasDevicePermissionFromDevice(perms, entity, 'createEdit');
  const canRemove =
    entityType === 'system'
      ? perms.testPermission([8, 9, 10, 11, 12, 13], ['DeleteIntegrations'])
      : hasDevicePermissionFromDevice(perms, entity, 'delete');

  if (!canEdit && !canRemove) return className ? <div className={className} /> : null;

  const setMenuOpen = (isOpen) => {
    setOpenMenus((current) => ({ ...current, [menuKey]: isOpen }));
  };

  const menu = (
    <BaseEllipsisMenu
      ariaLabel={`Actions for ${entity.system_name || entity.alias || entity.name || entityType}`}
      open={openMenus[menuKey]}
      onOpen={() => setMenuOpen(true)}
      onClose={() => setMenuOpen(false)}
    >
      {canEdit && (
        <Button
          className="w-100 text-center"
          variant="primary"
          onClick={() => {
            onEdit(entityType, entity);
            setMenuOpen(false);
          }}
        >
          Edit
        </Button>
      )}
      {canRemove && (
        <Button
          className="w-100 text-center"
          variant="danger"
          onClick={() => {
            onRemove(entity);
            setMenuOpen(false);
          }}
        >
          Remove
        </Button>
      )}
    </BaseEllipsisMenu>
  );

  return className ? (
    <div
      className={className}
      onClick={(event) => event.stopPropagation()}
      onMouseDown={(event) => event.stopPropagation()}
    >
      {menu}
    </div>
  ) : (
    menu
  );
};

export default ActionMenu;
